import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const CallerAPI = async (setCallers, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.get("/api/team/callers?page=" + currentPage + "&per_page=" + perpagedata);

        console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCallers(response.data.data.data);
        setLoading(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const InviteCallerAPI = async (params, setIsCallerAdd, setShowPopup, setShowInviteSpinner) =>
{    

    setShowInviteSpinner(true);

    try 
    {
        const response = await baseapi.post("/api/team/caller/invite", params);

        console.log("Data got successfully", response);

        setShowPopup(false);

        setShowInviteSpinner(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsCallerAdd(true);
        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    }

}

export const DeleteCallerAPI = async (callerid, setIsCallerDelete, setShowDeletePopup, setShowDeleteSpinner) =>
{
    setShowDeleteSpinner(true);

    try 
    {
        const response = await baseapi.get("/api/team/caller/delete/" + callerid);

        console.log("Data got successfully", response);

        setShowDeletePopup(false);

        setShowDeleteSpinner(false);
        
        if(response.data.code == 200)
        {
            successMesg(response.data.mesg);

            setIsCallerDelete(true);
        }
        else
        {
            errorMesg(response.data.mesg);
        }

    } 
    catch (error) 
    {
        console.error("Error in caller invite:", error);
        //setLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");

    }

}


